<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
        <CCard>
          <CCardHeader>
            Alertas
          </CCardHeader>
          <CCardBody>
            <CDataTable
              v-show="!loading"
              hover
              striped
              :items="items"
              :fields="fields"
              :items-per-page="pagination.perPage"
              @row-clicked="goToAlert"
              index-column
              clickable-rows
            >
              <template #name="data">
                <td>{{data.item.user.name}}</td>
              </template>
              <template #email="data">
                <td>{{data.item.user.email}}</td>
              </template>
              <template #estado="data">
                <td>
                  <CBadge :color="getBadge(data.item.estado)">{{getEstado(data.item.estado)}}</CBadge>
                </td>
              </template>
<!--               <template #actions="data">
                <CButton
                  color="warning"
                  size="sm"
                  class="m-1"
                  @click="updateUser(data.item, $event)"
                >
                  <font-awesome-icon icon="user-edit" />
                </CButton>
                <CButton
                  color="danger"
                  size="sm"
                  class="m-1"
                  @click="deleteUser(data.item.id, $event)"
                >
                  <font-awesome-icon icon="trash-alt" />
                </CButton>
              </template> -->
            </CDataTable>
            <div 
              v-if="loading"
              class="d-flex flex-column justify-content-center align-items-center" style="min-height: 300px;">
              <CSpinner
                style="width:4rem;height:4rem;"
                color="danger"
              />
              <p class="text-secondary my-2">Cargando datos ...</p>
            </div>
            <Pagination :data="pagination" :callback="paginate"/>
          </CCardBody>
        </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import Pagination from '../../helpers/Pagination'
import { getAlerts } from '../../api/alerts'

export default {
  name: 'Alerts',
  components: {Pagination},
  data: () => {
    return {
      items: [],
      dataLoading: true,
      fields: [
        { key: 'id', label: '#' },
        { key: 'name', label: 'Usuario' },
        { key: 'email' },
        { key: 'estado' },
        { key: 'created_at', label: 'Creada' },
        //{ key: 'actions', label: 'Acciones' }
      ],
      pagination: {
        page: 1,
        perPage: 10,
        total: null
      },
      updatingUser: null,
      showModal: false,
      loading: true
    }
  },
  mounted(){
    this.getAlerts()
  },
  methods: {
    paginate(page, perPage){
      console.log(page)
      console.log(perPage)
      this.pagination = {
        page: page,
        perPage: perPage,
        total: this.pagination.total
      }
      this.getAlerts()
    },
    goToAlert(alert){
      this.$router.push({path: 'alertas/' + alert.id})
    },
    closeModal(){
      this.showModal = false
      this.getUsers()
    },
    updateUser(user, e){
      e.stopPropagation()
      this.updatingUser = user
      this.showModal = true
    },
    deleteUser(id, e){
      e.stopPropagation()
      console.log(id)
      const data = {id}
      const self = this
      deleteUser(data)
        .then(function(resp){
          console.log(resp)
          self.getUsers()
        })
        .catch(function(error){
          console.log(error)
        })
    },
    getAlerts(){
      const data = {
        limit: this.pagination.perPage,
        page: this.pagination.page
      }
      console.log(data)
      const self = this
      this.loading = true
      getAlerts(data)
        .then(function(resp){
          self.items = resp.data
          self.pagination = {
            page: self.pagination.page,
            perPage: self.pagination.perPage,
            total: resp.total
          }
          self.loading = false
        })
        .catch(function(error){
          console.log(error)
        })
    },
    getBadge (status) {
      return status === 0 ? 'primary'
        : status === 1 ? 'danger'
        : status === 2 ? 'warning' : null
    },
    getEstado (status) {
      return status === 0 ? 'Activa'
        : status === 1 ? 'Cerrada'
        : status === 2 ? 'Acción Realizada' : null
    }
  }
}
</script>